// Statut d'un camion tel qu'on l'affiche.
//
// L'API garde `current_status` (le statut de répartition) et
// `technical_status` (l'état physique) séparés, si bien que d'anciens
// enregistrements portent légitimement FREE + MAINTENANCE. Un camion déclaré
// en maintenance ou en panne ne doit jamais apparaître comme disponible: on
// résout cette combinaison à la présentation, en attendant que la fiche
// maintenance soit réconciliée.

import { libelle, ton, tableAvecRepli } from './libelles';

const UTILS_TRUCK_STATUS_LABELS = tableAvecRepli('truckStatus', [
  'FREE',
  'ON_TRIP',
  'MAINTENANCE',
  'RENTED_OUT',
  'IMMOBILIZED',
  'RETURNED_TO_OWNER',
]);

export const effectiveTruckStatus = (truck) => {
  if (!truck) return 'FREE';
  if (truck.current_status === 'MAINTENANCE') return 'MAINTENANCE';
  if (truck.technical_status === 'MAINTENANCE' || truck.technical_status === 'BROKEN') {
    return 'MAINTENANCE';
  }
  return truck.current_status || 'FREE';
};

export const TRUCK_STATUS_LABELS = UTILS_TRUCK_STATUS_LABELS;

// Teinte de pastille par statut (classes de la charte: success / info /
// warning / destructive / muted), prise dans `ton` de lib/libelles.js.
export const TRUCK_STATUS_META = Object.fromEntries(
  ['FREE', 'ON_TRIP', 'MAINTENANCE', 'RENTED_OUT', 'IMMOBILIZED', 'RETURNED_TO_OWNER'].map((code) => [
    code,
    { label: libelle('truckStatus', code), tone: ton('truckStatus', code) },
  ]),
);

export const truckStatusLabel = (status) => libelle('truckStatus', status || 'FREE');
